export const NavbarLinks = [
  {
    title: "Home",
    path: "/",
    icon: "AiOutlineHome"
  },
  {
    title: "Catalog",
    // path: '/catalog',
  },
  {
    title: "About Us",
    path: "/about",
    icon: "AiOutlineUser",
  },
  {
    title: "Contact Us",
    path: "/contact",
    icon: "AiOutlineWechat"
  },
];
